import React from 'react';
import { SvgIconProps } from '@mui/material';
import {
  AccountTree,
  Dashboard,
  DeveloperBoard,
  Factory,
  NotificationsActive,
  Settings,
  Tv,
  Usb,
  ViewList,
  Hub,
} from '@mui/icons-material';
import SignalsIcon from '../icons/SignalsIcon';
import {
  ALERTS_PATH,
  CONTROLLERS_PATH,
  SETTINGS_PATH,
  CONTROLLERS_USB_PATH,
  DASHBOARD_PATH,
  INSTANCES_PATH,
  SETUP_DISPLAY_PATH,
  SETUP_FLOW_PATH,
  SETUP_SIGNALS_PATH,
  SHOPFLOOR_PATH,
} from './paths';

export interface NavItem {
  id: string;
  labelKey: string;
  hintKey?: string;
  path: string;
  icon: React.ComponentType<SvgIconProps>;
  matchPrefix?: boolean;
  mobilePrimary?: boolean;
  children?: NavItem[];
}

export const NAV_ITEMS: NavItem[] = [
  {
    id: 'dashboard',
    labelKey: 'nav.dashboard',
    path: DASHBOARD_PATH,
    icon: Dashboard,
    matchPrefix: true,
    mobilePrimary: true,
  },
  {
    id: 'shopfloor',
    labelKey: 'nav.shopfloor',
    path: SHOPFLOOR_PATH,
    icon: Factory,
    matchPrefix: true,
    mobilePrimary: true,
  },
  {
    id: 'alerting',
    labelKey: 'nav.alerting',
    path: ALERTS_PATH,
    icon: NotificationsActive,
    matchPrefix: true,
    mobilePrimary: true,
  },
  {
    id: 'flow',
    labelKey: 'nav.flow',
    path: SETUP_FLOW_PATH,
    icon: AccountTree,
    matchPrefix: true,
    mobilePrimary: true,
  },
  {
    id: 'display',
    labelKey: 'nav.layout',
    path: SETUP_DISPLAY_PATH,
    icon: Tv,
    matchPrefix: true,
    mobilePrimary: true,
  },
  {
    id: 'signals',
    labelKey: 'nav.signals',
    path: SETUP_SIGNALS_PATH,
    icon: SignalsIcon,
    matchPrefix: true,
    mobilePrimary: true,
  },
  {
    id: 'controllers',
    labelKey: 'nav.controllers',
    path: CONTROLLERS_PATH,
    icon: DeveloperBoard,
    matchPrefix: true,
    mobilePrimary: true,
    children: [
      {
        id: 'controllers-fleet',
        labelKey: 'nav.controllersFleet',
        path: CONTROLLERS_PATH,
        icon: ViewList,
      },
      {
        id: 'controllers-usb',
        labelKey: 'nav.usbFirmware',
        path: CONTROLLERS_USB_PATH,
        icon: Usb,
        matchPrefix: true,
      },
    ],
  },
  {
    id: 'instances',
    labelKey: 'nav.instances',
    path: INSTANCES_PATH,
    icon: Hub,
    matchPrefix: true,
  },
  {
    id: 'settings',
    labelKey: 'nav.settings',
    path: SETTINGS_PATH,
    icon: Settings,
    matchPrefix: true,
  },
];

export function isNavItemActive(item: NavItem, pathname: string): boolean {
  if (item.id === 'controllers-fleet') {
    return pathname === CONTROLLERS_PATH
      || (pathname.startsWith(`${CONTROLLERS_PATH}/`) && !pathname.startsWith(CONTROLLERS_USB_PATH));
  }
  if (item.matchPrefix) {
    return pathname === item.path || pathname.startsWith(`${item.path}/`);
  }
  return pathname === item.path;
}

export function activeNavId(pathname: string): string {
  const hit = NAV_ITEMS.find((item) => isNavItemActive(item, pathname));
  return hit?.id || NAV_ITEMS[0].id;
}
